module.exports = __webpack_public_path__ + "static/media/savvy-dir-index-html.895e268c.svg";